import { ComponentPrototype, isTrue } from '../../../abstract';
import { ChangeDetectorRef, Component, ElementRef, Injector } from '@angular/core';
import { SearchTermsQuery } from '../../state';
import { Observable } from 'rxjs';
import { SearchTermType } from '../../../shared/enums/typeahead';
import { filter, map } from 'rxjs/operators';
import { SearchTerm } from '../../state/search-term.model';
import { MusimapFiltersQuery } from '../musimap-services/musimap-filters.query';
import { MusimapFiltersService } from '../musimap-services/musimap-filters.service';
import { TypeaheadFiltersService } from '../../../search-area/typeahead-filters.service';
import { RecordingsService } from '../../../recordings/state';
import { Router } from '@angular/router';

@Component({
  selector: 'app-musimap-component-prototype',
  template: '<div></div>',
})
export class MusimapPrototypeComponent extends ComponentPrototype {
  public router: Router = this.injector.get(Router);
  public recordingsService: RecordingsService = this.injector.get(RecordingsService);

  public searchType$: Observable<SearchTermType> = this.searchQuery.selectFilters$.pipe(
    map(([searchTerm]: SearchTerm[]) => searchTerm),
    filter(isTrue),
    map((searchTerm: SearchTerm) => searchTerm.type)
  );

  constructor(
    public injector: Injector,
    public searchQuery: SearchTermsQuery,
    public cdr: ChangeDetectorRef,
    public ref: ElementRef,
    public filtersQuery: MusimapFiltersQuery,
    public filtersService: MusimapFiltersService,
    public typeahead: TypeaheadFiltersService
  ) {
    super();
  }

  public redirectToSearch = (): void => {
    if (this.router.url !== '/') {
      this.recordingsService.redirectToSearch();
    }
  };
}
